module.exports = __webpack_public_path__ + "static/team-18-c0007cce5db9a7cbfb708a70cc92fef1.jpg";